import { useContext, useReducer } from 'react'
import { Outlet } from 'react-router-dom'
import { mineralsReducer } from './mineralsReducer'
import { mineralsInitialState } from './mineralsInitialState'
import MineralsContext from './MineralsContext'

export const useMineralsContext = () => useContext(MineralsContext)

export function MineralsProvider() {
  const [mineralsState, mineralsDispatch] = useReducer(
    mineralsReducer,
    mineralsInitialState,
  )

  return (
    <MineralsContext.Provider value={{ mineralsState, mineralsDispatch }}>
      <Outlet />
    </MineralsContext.Provider>
  )
}
